import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Process from '../components/Process';
import Features from '../components/Features';
import AboutSection from '../components/AboutSection';
import MRVSection from '../components/MRVSection';
import TeamSection from '../components/TeamSection';
import ImpactSection from '../components/ImpactSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import CalculateModal from '../components/CalculateModal';
import SetupModal from '../components/SetupModal';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';
import { seoConfig } from '../config/seo';

const HomePage = () => {
  const [isCalculateOpen, setIsCalculateOpen] = useState(false);
  const [isSetupOpen, setIsSetupOpen] = useState(false);

  const scrollToContactForm = () => {
    const element = document.getElementById('contact-form');
    if (element) {
      const offset = 80; // Account for fixed navbar height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  // Structured Data for SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://www.bloomcycleinnovations.in/#organization",
        "name": "BloomCycle Innovations",
        "url": "https://www.bloomcycleinnovations.in",
        "logo": "https://www.bloomcycleinnovations.in/BLOOMCYCLE_INNOVATIONS-removebg-preview.webp",
        "description": "BloomCycle Innovations enables farmers to earn from biochar-based carbon removal with MRV, IoT soil monitoring, blockchain tracking, and biomass valorization.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "H.No 115-C, The Mark Residences, NRI Layout Main Rd 1st Block, Ramamurthy Nagar",
          "addressLocality": "Bangalore",
          "addressRegion": "Karnataka",
          "postalCode": "560016",
          "addressCountry": "IN"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "email": "support@bloomcycleinnovations.in",
          "contactType": "Customer Service"
        },
        "sameAs": [
          "https://www.linkedin.com/company/107438420/admin/dashboard/"
        ]
      },
      {
        "@type": "Product",
        "@id": "https://www.bloomcycleinnovations.in/#product",
        "name": "Biochar Carbon Removal Solution",
        "description": "MRV-verified biochar production system with IoT soil monitoring, satellite verification, and blockchain tracking for carbon credit generation.",
        "brand": {
          "@type": "Organization",
          "name": "BloomCycle Innovations"
        },
        "category": "Carbon Removal Technology",
        "offers": {
          "@type": "Offer",
          "availability": "https://schema.org/InStock",
          "priceCurrency": "INR"
        }
      },
      {
        "@type": "Service",
        "@id": "https://www.bloomcycleinnovations.in/#service",
        "name": "MRV-Integrated Carbon Removal",
        "description": "Monitoring, Reporting & Verification system for carbon removal using satellite imagery, IoT sensors, and blockchain technology.",
        "provider": {
          "@type": "Organization",
          "name": "BloomCycle Innovations"
        },
        "areaServed": "Worldwide",
        "serviceType": "Carbon Credit Verification"
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO {...seoConfig.home} />
      <StructuredData data={structuredData} />
      <Navbar />
      <Hero 
        onCalculateClick={scrollToContactForm}
        onSetupClick={() => setIsSetupOpen(true)}
      />
      <Stats />
      <AboutSection />
      <Process onSetupClick={() => setIsSetupOpen(true)} />
      <MRVSection />
      <Features />
      <TeamSection />
      <ImpactSection />
      <ContactSection />
      <Footer />
      
      <CalculateModal 
        isOpen={isCalculateOpen} 
        onClose={() => setIsCalculateOpen(false)} 
      />
      <SetupModal 
        isOpen={isSetupOpen} 
        onClose={() => setIsSetupOpen(false)} 
      />
    </div>
  );
};

export default HomePage;
